import { render, staticRenderFns } from "./config_list.vue?vue&type=template&id=8cd71db2"
import script from "./config_list.vue?vue&type=script&lang=js"
export * from "./config_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports